import React from 'react';

const AffinityContext = React.createContext({

    affinityId: null,
    affinityActive: null,
    affinityCodigoProductor: null,
    affinityName: null,
    affinityInterCode: null,
    affinityOrgCode: null,
    affinityaffinityAdvisers: null,
    affinityResponsable: null,
    affinityProducts: null,
    affinityPic: null,
    affinityQR: null,
    affinityLink: null,
    infoAuto: null,
    infoMoto: null,
    localidades: null,
    coberturasInfo: null,
    coberturaMotovehiculoInfo: null,
    adviserPhone: null,
    productOtros: null,
    coveragesToFilter: null,
    isReady: false,
});

export default AffinityContext;